module.exports = __webpack_public_path__ + "img/submission-icon.1c0dfa35.svg";